/**
 * 日本站 PC 产品详情页 — 服务介绍卡片配置
 * 位于右侧内容区，banner 图片与服务简介之间
 *
 * 结构：detailCode → 3 张卡片
 *   detailCode: URL 中的 detailName，即子产品的 code（fast / bulk / discts / delivery / package）
 *   每个 detailCode 下是一个数组，固定 3 项 { icon, titleKey, detailKey }
 *   titleKey / detailKey 对应 locales 中的 i18n key，由调用方用 $t 翻译
 *
 * 使用方式：
 *   import { getJpServiceCards } from './jpServiceCardData'
 *   const cards = getJpServiceCards(detailCode)
 *   // 在组件中用 this.$t(card.titleKey) / this.$t(card.detailKey) 翻译
 *   // 返回 null 时组件不展示
 *
 * 查找逻辑：
 *   1. detailCode 命中 → 返回对应 3 张卡片
 *   2. detailCode 没匹配 → 返回 null，组件不渲染
 */

const jpServiceCardMap = {
  // 1 = 国際スピードサービス（国際快递）— 3 个子产品
  fast: [
    { icon: require('@/assets/img/product-express-one.png'), titleKey: 'modules.jpProduct.card.fast.card1.title', detailKey: 'modules.jpProduct.card.fast.card1.detail' },
    { icon: require('@/assets/img/product-express.two.png'), titleKey: 'modules.jpProduct.card.fast.card2.title', detailKey: 'modules.jpProduct.card.fast.card2.detail' },
    { icon: require('@/assets/img/product-express-three.png'), titleKey: 'modules.jpProduct.card.fast.card3.title', detailKey: 'modules.jpProduct.card.fast.card3.detail' },
  ],
  bulk: [ // 国际大件
    { icon: require('@/assets/img/product-discount-one.png'), titleKey: 'modules.jpProduct.card.bulk.card1.title', detailKey: 'modules.jpProduct.card.bulk.card1.detail' },
    { icon: require('@/assets/img/product-discount-two.png'), titleKey: 'modules.jpProduct.card.bulk.card2.title', detailKey: 'modules.jpProduct.card.bulk.card2.detail' },
    { icon: require('@/assets/img/product-discount-three.png'), titleKey: 'modules.jpProduct.card.bulk.card3.title', detailKey: 'modules.jpProduct.card.bulk.card3.detail' },
  ],
  discts: [ // 国际特惠
    { icon: require('@/assets/img/product-bigData-one.png'), titleKey: 'modules.jpProduct.card.discts.card1.title', detailKey: 'modules.jpProduct.card.discts.card1.detail' },
    { icon: require('@/assets/img/product-bigData-two.png'), titleKey: 'modules.jpProduct.card.discts.card2.title', detailKey: 'modules.jpProduct.card.discts.card2.detail' },
    { icon: require('@/assets/img/product-bigData-three.png'), titleKey: 'modules.jpProduct.card.discts.card3.title', detailKey: 'modules.jpProduct.card.discts.card3.detail' },
  ],
  plsc: [ // 行李
    { icon: require('@/assets/img/product-plsc-one.png'), titleKey: 'modules.jpProduct.card.plsc.card1.title', detailKey: 'modules.jpProduct.card.plsc.card1.detail' },
    { icon: require('@/assets/img/product-plsc-two.png'), titleKey: 'modules.jpProduct.card.plsc.card2.title', detailKey: 'modules.jpProduct.card.plsc.card2.detail' },
    { icon: require('@/assets/img/product-plsc-three.png'), titleKey: 'modules.jpProduct.card.plsc.card3.title', detailKey: 'modules.jpProduct.card.plsc.card3.detail' },
  ],

  // 2 = 越境ECサービス（跨境电商）— 2 个子产品
  delivery: [
    { icon: require('@/assets/img/product-package-one.png'), titleKey: 'modules.jpProduct.card.delivery.card1.title', detailKey: 'modules.jpProduct.card.delivery.card1.detail' },
    { icon: require('@/assets/img/product-package-two.png'), titleKey: 'modules.jpProduct.card.delivery.card2.title', detailKey: 'modules.jpProduct.card.delivery.card2.detail' },
    { icon: require('@/assets/img/product-package-three.png'), titleKey: 'modules.jpProduct.card.delivery.card3.title', detailKey: 'modules.jpProduct.card.delivery.card3.detail' },
  ],
  package: [
    { icon: require('@/assets/img/product-package-one.png'), titleKey: 'modules.jpProduct.card.package.card1.title', detailKey: 'modules.jpProduct.card.package.card1.detail' },
    { icon: require('@/assets/img/product-package-two.png'), titleKey: 'modules.jpProduct.card.package.card2.title', detailKey: 'modules.jpProduct.card.package.card2.detail' },
    { icon: require('@/assets/img/product-package-three.png'), titleKey: 'modules.jpProduct.card.package.card3.title', detailKey: 'modules.jpProduct.card.package.card3.detail' },
  ],
}

/**
 * 根据 detailCode 获取卡片配置
 * @param {string} detailCode - 子产品的 code（URL 中的 detailName，如 fast / bulk / discts / delivery / package）
 * @returns {Array<object>|null} 3 张卡片配置数组（含 titleKey / detailKey），未匹配返回 null
 */
export function getJpServiceCards(detailCode) {
  if (detailCode && jpServiceCardMap[detailCode]) {
    return [...jpServiceCardMap[detailCode]]
  }
  return null
}
